import { useMemo, type ReactElement } from 'react'
import { CUSTOM_TABLE_TYPES, isTeamId } from '@terros/common'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Stack } from '@mantine/core'
import { useSelectedWorkflow } from '@hooks'
import { Size, useProfile, useTranslation, useWorkflows } from '@front/model'
import { ButtonAdd, Page, PermissionTooltip, TButton, WorkflowSelect } from '@components'
import { CustomFieldList } from './CustomFieldList'

function CustomFields(): ReactElement {
  const { t } = useTranslation()
  const { workflowId } = useSelectedWorkflow()
  const { data: workflows } = useWorkflows()
  const { company } = useProfile()

  const selectedWorkflow = useMemo(() => {
    return workflows?.find((workflow) => workflow.workflowId === workflowId)
  }, [workflowId, workflows])

  const permissionIds = useMemo(() => {
    if (!selectedWorkflow) return company?.companyId
    return [...(selectedWorkflow?.visibleTo?.filter(isTeamId) ?? []), selectedWorkflow?.companyId]
  }, [company?.companyId, selectedWorkflow])

  return (
    <Page>
      <Page.Heading title='Custom Fields'>
        <WorkflowSelect />
        <PermissionTooltip targetId={permissionIds} permissionType='customField:save'>
          <ButtonAdd component={Link} to='add' />
        </PermissionTooltip>
        <TButton component={Link} icon='archive' to='trash' tooltip={t('View Trash')} variant='secondary' />
      </Page.Heading>
      <Page.Content scrollArea>
        <Stack gap={Size.space['4xl']}>
          {CUSTOM_TABLE_TYPES.map((tableType) => (
            <CustomFieldList key={tableType} tableType={tableType} workflowId={workflowId} />
          ))}
        </Stack>
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/settings/customField/')({
  component: CustomFields,
})
